import { render, staticRenderFns } from "./TicketGroup.vue?vue&type=template&id=1f00d6b4"
import script from "./TicketGroup.vue?vue&type=script&lang=js"
export * from "./TicketGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports